<template>
  <div id="vin_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="srtHeader">Report a Concern</span>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content srt-create">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ConcernForm">
                <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 15px">
                  <img :src="logoPath" alt="Dealer Pro" style="height: 35px; margin-right: 7px">
                  <span style="font-weight: bold; font-style: italic; color:#012d6b; font-size: 18px;margin-right: 7px">
                    DealerPro
                  </span>
                  <img :src="flagPath" alt="Country Flag" style="margin-left: 0px; height: 35px">
                </div>
                <p style="text-align: center">
                  <b>If you encounter a problem or concern with Rizon DealerPro, we want to know. Please take a moment
                    and
                    provide us with details so we can investigate and take corrective action.</b>

                </p>
                <p style="text-align: center">
                  <b>Please provide as much detail as possible including
                    screenshots whenever possible.</b>
                </p>
                <div class="col form-group">
                  <h4>DealerPro Section of Concern</h4>
                </div>
                <div class="col form-row row" style="margin-bottom:35px">
                  <div class="col-md-2 col-12 form-group" style="display: flex; align-items: center;">
                    <input type="checkbox" class="form-control" v-model="vehicle_management" id="vehicle_management"
                      name="vehicle_management" style="width: 20px; height: 20px; margin-right: 8px;">
                    <label for="vehicle_management" class="control-label" style="margin: 0;">
                      Vehicle Management
                    </label>
                  </div>

                  <div class="col-md-2 col-12 form-group" style="display: flex; align-items: center;">
                    <input type="checkbox" class="form-control" v-model="parts" id="parts" name="parts"
                      style="width: 20px; height: 20px; margin-right: 8px;">
                    <label for="parts" class="control-label" style="margin: 0;">
                      Parts
                    </label>
                  </div>

                  <div class="col-md-2 col-12 form-group" style="display: flex; align-items: center;">
                    <input type="checkbox" class="form-control" v-model="warranty" id="warranty" name="warranty"
                      style="width: 20px; height: 20px; margin-right: 8px;">
                    <label for="warranty" class="control-label" style="margin: 0;">
                      Warranty
                    </label>
                  </div>

                  <div class="col-md-2 col-12 form-group" style="display: flex; align-items: center;">
                    <input type="checkbox" class="form-control" v-model="publications" id="publications"
                      name="publications" style="width: 20px; height: 20px; margin-right: 8px;">
                    <label for="publications" class="control-label" style="margin: 0;">
                      Publications
                    </label>
                  </div>

                  <div class="col-md-2 col-12 form-group" style="display: flex; align-items: center;">
                    <input type="checkbox" class="form-control" v-model="campaign_recalls" id="campaign_recalls"
                      name="campaign_recalls" style="width: 20px; height: 20px; margin-right: 8px;">
                    <label for="campaign_recalls" class="control-label" style="margin: 0;">
                      Campaign/Recalls
                    </label>
                  </div>
                </div>

                <div class="col form-group" style="margin-bottom:35px">
                  <label class="control-label require" for="comment">Comment:</label>
                  <textarea class="form-control" v-model="comment" ref="textarea" id="comment" rows="5"></textarea>
                  <span class="field-error">{{ commentErrorMsg }}</span>
                </div>

                <div class="col form-group" style="margin-bottom:35px">
                  <h3 class="color-darkblue"> Attachment </h3>
                  <DropZone ref="dropzoneComponentRef" :uniqueRef="'dropzoneInstance'" :showDropzone="true"
                    :showUploadedFiles="false" :maxFileLimit='5' :docErrorMsg="doc_error_msg" :dropZonePreviewFiles="[]"
                    :dropzoneLabel="''" @dropzone-update-files="updateFiles" />
                </div>

                <div class="col form-group">
                  <h4>Contact Information</h4>
                </div>

                <div class="col form-row row">
                  <div class="col form-group">
                    <label class="control-label require" for="comment">Name:</label>
                    <input type="text" class="form-control" v-model="userName" ref="name" id="name">
                    <span class="field-error">{{ userNameErrorMsg }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="comment">Email:</label>
                    <input type="text" class="form-control" v-model="email" ref="email" id="email">
                    <span class="field-error">{{ emailErrorMsg }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="comment">Phone:</label>
                    <input type="text" class="form-control" v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }"
                      v-model="phone" id="phone_no" data-val="PHONE" data-info="Please enter phone number"
                      placeholder="999-999-9999" name="phone_no" @keypress="isNumber($event)" ref="phoneInput">

                    <!--                    <input type="text" class="form-control" v-model="phone" ref="phone" id="phone"></input>-->
                    <span class="field-error">{{ phoneErrorMsg }}</span>
                  </div>
                </div>

                <div class="btn-groups">
                  <button type="submit" id="createSrtBtn" class="btn btn-primary" v-on:click.prevent="submitForm">
                    Submit
                  </button>
                  <button type="submit" id="cancelSrtBtn" class="btn btn-tertiary"
                    v-on:click.prevent="cancellationConfirmation">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import DropZone from './DropZone.vue';


import LoadingContent from "@/components/LoadingContent.vue";

Vue.component("loading-content", LoadingContent);
import { commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';

export default {
  name: "UserFeedbackCreate",
  components: {
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
    DropZone,
  },
  mixins: [commonMixins, contractMixins],
  metaInfo() {
    return { title: "Report a Concern | " + process.env.COPYRIGHT_NAME }
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    comment: "",
    vehicle_management: false,
    parts: false,
    warranty: false,
    publications: false,
    campaign_recalls: false,
    logoPath: "",
    flagPath: "",
    userName: "",
    email: "",
    phone: "",
    commentErrorMsg: "",
    userNameErrorMsg: "",
    emailErrorMsg: "",
    phoneErrorMsg: "",
    doc_error_msg: "",
    files: [],
    reportConcernFormData: '',
    initialReportConcernFormData: ''
  }),
  created: function () {

    this.logoPath = process.env.LOGO_PATH;
    this.flagPath = process.env.FLAG_LOGO_PATH;

  },
  watch: {
    //check permission change
    permissions: function (permissions) {
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name === 'ev_create_feedback') {
            this.cantAccessPage = true;
          }
        }
      }
    },
  },
  mounted: function () {
    this.getPermissions();
    this.populateFormData(true);
  },
  methods: {
    updateFiles(files) {
      this.files = files;
    },
    submitForm() {
      var self = this;
      let validity = this.validateFormFields();
      if (validity) {
        self.loading = true;
        let fields = self.prepareFormFields();
        $.ajax({
          url: process.env.ROOT_API + "/user-feedback/create",
          type: "POST",
          data: fields,
          headers: {
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          crossDomain: true,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status === "success") {
              self.showSuccessPopUp();
            } else {
              console.log("Error!!");
            }
          },
          error: function (jqXHR) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'user-feedback-create')
          }
        })
      } else {
        self.loading = false;
      }
    },
    validateFormFields() {
      this.commentErrorMsg = "";
      this.userNameErrorMsg = "";
      this.emailErrorMsg = "";
      this.phoneErrorMsg = "";

      let validity = true;

      if (this.comment === "" || this.comment == null) {
        this.commentErrorMsg = "Please enter comment!";
        validity = false;
      }
      if (this.userName.trim() === "" || this.userName == null) {
        this.userNameErrorMsg = "Please enter Name!";
        validity = false;
      }
      if (this.email === "" || this.email == null) {
        this.emailErrorMsg = "Please enter Email!";
        validity = false;
      } else {
        var emailValidity = this.validEmail(this.email);
        if (!emailValidity) {
          validity = false;
          this.emailErrorMsg = "Please enter valid email"
        }
      }
      if (this.phone === "" || this.phone == null) {
        this.phoneErrorMsg = "Please enter phone number!";
        validity = false;
      } else {
        var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if (!this.phone.match(phoneRE)) {
          this.phoneErrorMsg = "Please enter valid phone number";
          validity = false;
        }
      }
      return validity;
    },
    prepareFormFields() {
      var fields = {
        vehicleManagement: this.vehicle_management,
        parts: this.parts,
        warranty: this.warranty,
        publications: this.publications,
        campaignRecalls: this.campaign_recalls,
        comment: this.comment,
        userName: this.userName,
        email: this.email,
        phone: this.phone,
        files: this.files
      }

      let formData = new FormData();
      formData.append("concernData", JSON.stringify(fields));
      return formData;
    },
    showSuccessPopUp() {
      var successText = "Thank you for submitting your concern, our team will review the information that you have provided and may contact you for further information or with an update."
      this.$swal({
        title: "Your concern has been submitted!",
        html: `<p class='text-center'>${successText}</p>`,
        type: 'success',
        showConfirmButton: true,
        confirmButtonText: 'CLOSE',
        cancelButtonText: 'cancel',
        showCancelButton: false,
      }).then(() => {
        this.clearFormFields();
      });
    },
    cancellationConfirmation() {
      if (this.hasFormChanged()) {
        this.$swal({
          title: 'Are you sure you want to cancel the feedback?',
          type: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.clearFormFields();
          }
        });
      } else {
        this.scrollToTop();
      }
    },
    clearFormFields() {
      this.vehicle_management = false;
      this.parts = false;
      this.warranty = false;
      this.publications = false;
      this.campaign_recalls = false;
      this.comment = "";
      this.commentErrorMsg = "";
      this.userName = "";
      this.userNameErrorMsg = "";
      this.email = "";
      this.emailErrorMsg = "";
      this.phone = "";
      if (this.$refs.phoneInput && this.$refs.phoneInput.cleave) {
        this.$refs.phoneInput.cleave.setRawValue(''); // Clears the Cleave formatting
      }
      this.phoneErrorMsg = "";
      this.files = [];
      this.$nextTick(() => {
        if (
          this.$refs.dropzoneComponentRef
          &&
          this.$refs.dropzoneComponentRef.$refs.dropzoneInstance
        ) {
          this.$refs.dropzoneComponentRef.$refs.dropzoneInstance.removeAllFiles();
        }
      });
      this.scrollToTop();
    },
    checkFileSize(file) {
      var self = this;
      self.fileErrorMsg = "";
      if (file.size >= 26214400) {
        self.fileErrorMsg = "The file size is too large. Please upload a file smaller than 25MB.";
        self.$refs.documentDropzone.removeFile(file);
        return;
      }
    },
    storeDocument(file, response) {
      var self = this;
      self.doc_error_msg = "";
      var uploadResponse = response.content;

      if (self.files.length > 0) {
        var idx = self.files.findIndex((obj) => obj == uploadResponse);
        if (idx == -1) {
          self.files.push(uploadResponse);
        }
      } else {
        self.files.push(uploadResponse);
      }

      if (file.type != undefined) {
        var extension = file.type.split("/");
      }
    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      var orderId = "";
      if (file.status !== "error" && file.xhr) {
        const fileName = JSON.parse(file.xhr.response).content;
        const fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1], orderId)
          .then(() => {
            const index = self.files.findIndex(f => f.includes(fileName));
            if (index !== -1) {
              self.files.splice(index, 1);
            }
          })
          .catch(error => {
            console.error("Error removing file from server:", error);
          })
          .finally(() => {
            self.loading = false;
          });
      }
    },
    removeServerFile(fileName, key) {
      var self = this;
      if (confirm('Are you sure that you want to remove file? ')) {
        if (!self.isEdit) {
          self.removeFileFromServer(fileName);
        }
        self.dropZonePreviewFiles.splice(key, 1);

        //remove file from files array
        for (var i = 0; i < self.files.length; i++) {
          if (self.files[i].includes(fileName)) {
            self.files.splice(i, 1);
          }
        }
      }
    },
    removeFileFromServer(file) {
      var self = this;
      self.loading = true;
      return new Promise((resolve, reject) => {
        $.ajax({
          url: process.env.ROOT_API + "/remove-docs-from-temp",
          type: "POST",
          data: {
            filePath: file,
          },
          headers: self.ajxHeaders,
          dataType: "json",
          success: data => {
            resolve(data);
            self.loading = false;
          },
          error: (jqXHR, textStatus, errorThrown) => {
            reject(errorThrown);
          }
        });
      });
    },
    populateFormData(populateInitialData = false) {
      var formData = {
        vehicle_management: this.vehicle_management,
        parts: this.parts,
        warranty: this.warranty,
        publications: this.publications,
        campaign_recalls: this.campaign_recalls,
        comment: this.comment,
        files: this.files = [],
        userName: this.userName,
        email: this.email,
        phone: this.phone,
      }
      this.reportConcernFormData = JSON.stringify(formData);

      if (populateInitialData) {
        this.populateIntialFormData();
      }
    },
    populateIntialFormData() {
      this.initialReportConcernFormData = this.reportConcernFormData;
    },
    hasFormChanged() {
      this.populateFormData();
      // Compare the current form data with the initial form data
      return this.reportConcernFormData !== this.initialReportConcernFormData;
    },
  }
};
</script>

<style scoped>
.data-table table {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserFeedbackCreate.vue